import { Helmet } from "react-helmet-async";
import { FREE_SHIPPING_COPY } from "@/lib/shipping";

interface OGTagsProps {
  title?: string;
  description?: string;
  /** Omitted: the document keeps the share image it was served with — the
   *  prerendered page's own, or index.html's sitewide one — and gets the
   *  sitewide one back after an in-app navigation (src/lib/prerenderedHead.ts). */
  image?: string;
  url?: string;
  type?: string;
  canonical?: string;
  /** Search/filter style pages should not be indexed. */
  noindex?: boolean;
}

const SITE_URL = "https://loftloom.com";

export const OGTags = ({
  title = "LoftLoom — Modern Loft Furniture",
  description = `Discover curated modern furniture designed for loft spaces. Sofas, dining, bedroom, office & outdoor. ${FREE_SHIPPING_COPY}.`,
  image,
  url,
  type = "website",
  canonical,
  noindex = false,
}: OGTagsProps) => {
  const currentPath =
    typeof window !== "undefined" ? window.location.pathname + window.location.search : "/";
  const resolvedUrl = url || `${SITE_URL}${currentPath}`;
  const resolvedCanonical = canonical || url || `${SITE_URL}${currentPath}`;

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      {noindex ? <meta name="robots" content="noindex, follow" /> : null}
      {noindex ? null : <link rel="canonical" href={resolvedCanonical} />}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      {image ? <meta property="og:image" content={image} /> : null}
      <meta property="og:url" content={resolvedUrl} />
      <meta property="og:type" content={type} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      {image ? <meta name="twitter:image" content={image} /> : null}
    </Helmet>
  );
};
